/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, shallowEqual } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PreviewScreenshot from '../PreviewScreenshot';
import OverallResultSection from '../result/OverallResultSection';
import { getFreeCtaLink } from '../../constants/TrialConstants';
import { getDesktopPreview } from '../../selectors/Preview';
import { parseUtmParams } from '../../util/Urls';
import LangUtils from '../../util/LanguageUtil';
import usageTracker from '../../lib/usageTracker';
import styled from 'styled-components'; // do not remove before WSG widget results page v2 or widget will break.

const Gradient = styled.div.withConfig({
  displayName: "OverallPage__Gradient",
  componentId: "isou4i-0"
})(["background:", ";position:absolute;height:600px;top:0;width:100%;"], ({
  theme
}) => theme.resultsPage.overallResults.background);

const LangButton = ({
  websiteUrl
}) => {
  const parsedUtmParams = parseUtmParams();
  const lang = LangUtils.getLangKey();

  const handleClick = () => {
    usageTracker.log('academyCourseClick', {
      action: 'clicked-start-free-course-button',
      websiteUrl,
      source: 'results-header'
    });
  };

  return /*#__PURE__*/_jsx("a", {
    className: "button lg",
    href: `${getFreeCtaLink(lang, 'top-cta')}&${parsedUtmParams}`,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trialBanner.ctaButtonFree"
    })
  });
};

export default (({
  websiteGrade,
  hideCTAs = false
}) => {
  const {
    url,
    error
  } = useSelector(getDesktopPreview, shallowEqual);
  const domain = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered overall-page",
    id: "overall",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(Gradient, {
          className: "bg-gradient"
        }), /*#__PURE__*/_jsx(OverallResultSection, {
          websiteGrade: websiteGrade
        }), !hideCTAs && /*#__PURE__*/_jsx(LangButton, {
          websiteUrl: domain
        }), /*#__PURE__*/_jsx(PreviewScreenshot, {
          previewUrl: url,
          error: error
        })]
      })
    })
  });
});